import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { useTenantUserRemoveMutation } from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypePicker from "@/v2-backoffice-client/tenant/user/type/TenantUserTypePicker"

export type UserTenantManageMemberItemProps = {
  userTenant: UserTenantFragment
  userId: number
  onRemoved(): void
}

function UserTenantManageMemberItem(props: UserTenantManageMemberItemProps) {
  const { userTenant, userId, onRemoved } = props

  const [remove, { error, loading }] = useTenantUserRemoveMutation()
  errorToast(error, { title: "Failed to remove from team" })

  function handleRemove() {
    remove({ variables: { tenantId: userTenant.TenantId, userId } })
    onRemoved()
  }

  const tenant = userTenant.Tenant

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={tenant?.Name}
        secondary={tenant?.CustomerName ?? undefined}
      />
      <TenantUserTypePicker size="xs" userTenant={userTenant} />
      <ConfirmButton
        isLoading={loading}
        size="xs"
        variant="destructive"
        isSquare
        iconSrc="trash"
        content="Remove user from team"
        confirmContent="Remove?"
        confirmVariant="destructive"
        onConfirm={handleRemove}
      />
    </Manage.Item>
  )
}

export default UserTenantManageMemberItem
